export { default, MerchandisingMessage } from './merchandising-message'
